import { createTheme } from "@mui/material/styles";
import "./fonts.css";

// Detect system dark mode preference
const prefersDarkMode = window.matchMedia(
  "(prefers-color-scheme: dark)"
).matches;

const theme = createTheme({
  palette: {
    mode: prefersDarkMode ? "dark" : "light", // Automatically sets dark/light
    ...(prefersDarkMode
      ? {
          // Dark mode overrides
          primary: { main: "#830051" },
          text: { primary: "#e2e2e6", secondary: "#b3b3b3" },
          background: {
            default: "#15161c",
            paper: "#202123",
          },
        }
      : {
          // Light mode overrides
          primary: { main: "#B50070" },
          text: { primary: "#202123", secondary: "#3D3D3D" },
          background: {
            default: "#f7f7f8",
            paper: "#fff",
          },
        }),
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export default theme;
